module.exports = __webpack_public_path__ + "img/carshina22_11.ccac8778.jpg";